"use client";

import { ReactNode } from "react";
import Tooltip from "@/components/design-system/tooltip";
import styles from "./popoverError.module.scss";

function PopoverError({ children, show, target, closeCallback }: PopoverErrorProps) {
  if (!show || !target) {
    return null;
  }

  return (
    <Tooltip
      anchor={target}
      open
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          closeCallback();
        }
      }}
      trigger="click"
      label="Add to cart error"
      tailPlacement="above"
      content={
        <div className={styles.body} role="alert">
          {children}
        </div>
      }
    />
  );
}

type PopoverErrorProps = {
  children: ReactNode;
  show: boolean;
  target: HTMLElement | null;
  closeCallback: () => void;
};

export default PopoverError;
